
<template>
    <label class="app-textarea" >
        <div>
            {{ label }}
        </div>
        <div class="app-textarea__container" :data-replicated-value="state">
            <textarea v-model="state" class="app-input app-textarea__textarea" :rows="rows" :class="{ center: center }" :name="name"></textarea>
        </div>
    </label>
  </template>
  
  <script>
  export default {
    name: 'app-textarea',
    props: {
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      rows: {
        type: Number,
        default: 1,
      },
      center: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        default: '',
      },
    },
    computed: {
      state: {
        get() {
          return this.value;
        },
  
        set(value) {
          this.$emit('input', value);
        },
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .app-textarea {
    display: block !important;

    &__container {
        position: relative;
  
        // https://css-tricks.com/the-cleanest-trick-for-autogrowing-textareas/
  
        display: grid;
        flex-grow: 1;
        font-size: 14px;
        margin-top: 0.4rem;
    
        word-break: break-word;
        
        &::after,
        textarea {
        grid-area: 1 / 1 / 2 / 2;

        line-height: 1.32;
        }
    
        &::after {
        content: attr(data-replicated-value) ' ';
    
        padding: 8px;
    
        white-space: pre-wrap;
        word-break: break-word;
    
        visibility: hidden;
        border: 1px solid transparent;
        }
    }
  
    &__textarea {
      resize: none;
  
      overflow: hidden;
      font-family: Arial;
      height: auto !important;
      min-height: 3.8rem;
      font-size: 14px !important;

     line-height: 1.3 !important;

      &.center {
        text-align: center;
      }
    }
  
  }
  </style>
  